/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ publication: NonNullable<unknown> }} Onboarding_V1_Press_Mark_LabelInputs */

const en_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Featured in ${i?.publication}`)
};

const de_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorgestellt in ${i?.publication}`)
};

const pt_br2_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Destaque em ${i?.publication}`)
};

const tr_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Şurada yer aldı: ${i?.publication}`)
};

const zh_cn2_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`获 ${i?.publication} 报道`)
};

const zh_hk2_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`獲 ${i?.publication} 報道`)
};

const ko_kr2_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.publication} 소개`)
};

const ru_ru2_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Материал в ${i?.publication}`)
};

const es_419_onboarding_v1_press_mark_label = /** @type {(inputs: Onboarding_V1_Press_Mark_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Destacado en ${i?.publication}`)
};

/**
* | output |
* | --- |
* | "Featured in {publication}" |
*
* @param {Onboarding_V1_Press_Mark_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_mark_label = /** @type {((inputs: Onboarding_V1_Press_Mark_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_Mark_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_mark_label(inputs)
	if (locale === "de") return de_onboarding_v1_press_mark_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_mark_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_mark_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_mark_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_mark_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_mark_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_mark_label(inputs)
	return es_419_onboarding_v1_press_mark_label(inputs)
});